module.exports = __webpack_public_path__ + "img/Slide14.62346986.png";